const apiBase = import.meta.env.API_BASE_URL

export const API = {
	base: apiBase,

	AUTH: {
		token: 'auth/token',
		phone: 'auth/phone',
		code: 'auth/code',
		check: 'auth/check',
		tfa: 'auth/tfa',
		me: 'auth/me',
		pushToken: 'user/pushtoken',
	},

	USERS: {
		get: 'admin/users/user/',
		latest: 'admin/users/latest',
		search: 'admin/users/search',
		create: 'admin/users/create',
		update: 'admin/users/update',
		delete: 'admin/users/delete',
		tfa: 'admin/users/tfa',
		chat: 'admin/users/chat/',
		admins: 'admin/users/admins',
		supports: 'admin/users/supports',
		bonuses: 'admin/users/bonuses',
		sessions: 'admin/users/sessions',
		scans: 'admin/users/scans',
		startConsultation: 'admin/users/start-consultation',
		subscriptions: 'admin/users/subscriptions',
		cancelSubscription: 'admin/users/subscriptions/cancel',
		createFree: 'admin/users/subscriptions/create-free',
		cancelFree: 'admin/users/subscriptions/cancel-free',
	},

	SPACES: {
		upload: 'admin/spaces/upload',
	},

	PETS: {
		search: 'admin/pets/search',
		get: 'admin/pets/pet/',
		list: 'admin/pets/list',
		update: 'admin/pets/update',
		remove: 'admin/pets/remove',
	},

	EVENTS: {
		future: 'admin/events/future',
		history: 'admin/events/history',
		update: 'admin/events/update',
		remove: 'admin/events/remove',
	},

	STORIES: {
		get: 'admin/stories/story/',
		list: 'admin/stories/list',
		update: 'admin/stories/update',
		delete: 'admin/stories/delete',
	},

	CHATS: {
		get: 'admin/chats/chat/',
		forUser: 'admin/chats/user/',
		list: 'admin/chats/list',
		more: 'admin/chats/more',
		send: 'admin/chats/send',
		message: 'admin/chats/message/',
		updateMessage: 'admin/chats/message/',
		deleteMessage: 'admin/chats/message/',
		startTyping: 'admin/chats/typing/start',
		stopTyping: 'admin/chats/typing/stop',
		markAsRead: 'admin/chats/mark-read',
	},

	TICKETS: {
		get: 'admin/tickets/ticket/',
		list: 'admin/tickets/list',
		take: 'admin/tickets/take',
		close: 'admin/tickets/close',
		merge: 'admin/tickets/merge',
		changeLine: 'admin/tickets/change-line',
		history: 'admin/tickets/history',
		messages: 'admin/tickets/messages',
	},

	CALLS: {
		get: 'admin/calls/call/',
		list: 'admin/calls/list',
		take: 'admin/calls/take',
		upadte: 'admin/calls/update',
	},

	ARTICLES: {
		get: 'admin/articles/article/',
		list: 'admin/articles/list',
		update: 'admin/articles/update',
		upload: 'admin/articles/upload',
		updateCat: 'admin/articles/update-cat',
		removeCat: 'admin/articles/remove-cat',
		sortCat: 'admin/articles/sort-cat',
	},

	MEDICS: {
		list: 'admin/medics/list',
		update: 'admin/medics/update',
	},

	SERVICES: {
		petMap: 'admin/services/petmap',
		petMapCategories: 'admin/services/petmap/categories',
		petFood: 'admin/services/petfood',
		petBreeds: 'admin/services/petbreeds',
	},

	DOCUMENTS: {
		get: 'admin/documents/doc/',
		list: 'admin/documents/list',
	},

	PETMEDIA: {
		list: 'admin/petmedia/list',
	},

	CONSULTATIONS: {
		get: 'admin/consultations/consultation/',
		list: 'admin/consultations/list',
	},

	PROMOCODES: {
		create: 'admin/promocodes/create',
		list: 'admin/promocodes/list',
		update: 'admin/promocodes/update',
		delete: 'admin/promocodes/delete',
		users: 'admin/promocodes/users',
	},

	OFFERS: {
		create: 'admin/offers/create',
		list: 'admin/offers/list',
		update: 'admin/offers/update',
		delete: 'admin/offers/delete',
	},

	SEGMENTS: {
		create: 'admin/segments/create',
		list: 'admin/segments/list',
		update: 'admin/segments/update',
		delete: 'admin/segments/delete',
		users: 'admin/segments/users',
		push: 'admin/segments/push',
	},

	BREEDPREDICTS: {
		list: 'admin/breed-predicts/list',
	},

	GODS: {
		stats: 'admin/gods/stats',
	},
}

export const PUSHER = {
	authEndpoint: apiBase + '/auth/pusher',
	host: import.meta.env.PUSHER_HOST,
	key: import.meta.env.PUSHER_APP_KEY,
}

export const FIREBASE = {
	pushKey:
		'BNboULK8NyKmcmlpzmxtCrcf4I9oAJ0rtobRO_rHXhNz84klyBU_ifTizKqpmhYJ-kHOq7-Ckxj2Y5XZXNskOcY',
	config: {
		apiKey: 'AIzaSyCHGq2Ofwo0F-4p6BfruSnWFIOpDNWsFf0',
		authDomain: 'lapka-ad8fb.firebaseapp.com',
		projectId: 'lapka-ad8fb',
		messagingSenderId: '956026400983',
		appId: '1:956026400983:web:3ab0fbc523a9faf8d7c092',
	},
}

export const MAPBOX = {
	token: 'pk.eyJ1IjoibGFwa2FhcHAiLCJhIjoiY2twZmExOGlwMGcwdDJ2cmk0bjJpZTN3NyJ9.STQt9yVX-xRuRJsWih8eww',
	style: 'mapbox://styles/lapkaapp/ckqsl6dxp211p18pf5iem074p',
}

export default {
	apiBase,
	API,
	PUSHER,
	FIREBASE,
	MAPBOX,
}
